import { useEffect, useRef } from 'react';
import {
  toExchangeStatusUpdated,
  type ExchangeStatusUpdated,
  type WsEventNew,
  type WsGlobalEvent,
} from '@sunflower-games/predictions-realtime-contracts';
import { useRealtimeManager } from '../realtime-manager-ctx';

export interface GlobalEventsHandlers {
  /**
   * Fires when Plaee adds a brand-new event. Internal id is unknown until a
   * REST refetch resolves it — the raw eventKey is passed through.
   */
  onEventNew?: (raw: WsEventNew) => void;
  onExchangeStatusUpdated?: (e: ExchangeStatusUpdated) => void;
}

export function useGlobalEventsRealtime(handlers: GlobalEventsHandlers): void {
  const manager = useRealtimeManager();
  const handlersRef = useRef(handlers);
  useEffect(() => {
    handlersRef.current = handlers;
  });

  useEffect(() => {
    return manager.subscribeGlobalEvents((raw) => {
      const msg = raw as WsGlobalEvent;
      const h = handlersRef.current;
      switch (msg.type) {
        case 'event_new':
          h.onEventNew?.(msg);
          return;
        case 'exchange_status_updated':
          h.onExchangeStatusUpdated?.(toExchangeStatusUpdated(msg));
          return;
      }
    });
  }, [manager]);
}
